import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useUpdateDonationSurveyMutation = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data?: Api.IDonationSurvey) => void;
}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ survey }: { survey: Api.IDonationSurvey }) => {
			return userSession.webServiceHelper.callAsync<Api.IDonationSurvey>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `survey/donation/${survey.id}`,
				}),
				'PUT',
				survey
			);
		},
		onError,
		onSuccess,
	});
};
